/* eslint-disable no-alert */

/* eslint-disable no-restricted-globals */
(() => {
  if (!customElements.get("customer-address-form")) {
    class CustomerAddresses extends HTMLElement {
      constructor() {
        super();

        this.editAddressesForm = null;
      }

      connectedCallback() {
        this.editAddressesForm = this.querySelector(".js-edit-address-form");

        if (!this.editAddressesForm) {
          return;
        }

        const selectElement = this.editAddressesForm.querySelector("select");
        const defaultLocalizedCountry = selectElement.dataset.default;
        if (selectElement.value === "---") {
          selectElement.value = "Germany";
        } else {
          selectElement.childNodes.forEach((option) => {
            if (option.textContent === defaultLocalizedCountry) {
              selectElement.value = option.value;
            }
          });
        }
      }
    }

    customElements.define("customer-address-form", CustomerAddresses);
  }
})();
